import uniqId from 'uniq-id'

export default {
    addMessage: ({ commit, state }, message) => {
        const alreadyExistMessage = state.messages.find(it => {
            let equal = true

            Object.keys(message).forEach(key => {
                if (it[key] && it[key] != message[key]) {
                    equal = false
                }
            })

            return equal
        })

        if (alreadyExistMessage) {
            commit('REMOVE_MESSAGE', alreadyExistMessage.id)
        }

        const messageObj = Object.assign({ id: uniqId(), time: message.time || 2000 }, message)

        commit('ADD_MESSAGE', messageObj)

        setTimeout(() => commit('REMOVE_MESSAGE', messageObj.id), messageObj.time)
    }
}
